module.exports = __webpack_public_path__ + "img/yaakov.85474c44.png";